var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteEntranceIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "nonzero",
    d: "M16.122 13.443l-4.157-3.99 4.157-3.991v3.005h7.286v1.971h-7.286v3.005zm5.198 3.033v-3.004l4.157 3.99-4.157 3.99v-3.004h-7.287v-1.972h7.287z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#757575",
    d: "M1 25V1h17.693l.028 5.99M18.72 11.892v3.102M18.72 19.925V25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteEntranceIconBlack);
export default __webpack_public_path__ + "static/media/site_entrance_icon_black.10f6f23a7988b81759d50d9ba0e8b00b.svg";
export { ForwardRef as ReactComponent };